import { Link } from "react-router-dom";
import { useAuth0 } from "../../../contexts/AuthManager/Auth";
import styled from "styled-components/macro";
import { darkBlue } from "../../../constants/colors";

export const ErrorStyles = styled.div<{
  $isFullWidth?: boolean;
}>`
  position: relative;
  z-index: 1;
  padding-top: 20px;
  line-height: 1.5em;
  box-sizing: border-box;
  margin: auto;
  padding: ${props => (props.$isFullWidth ? "0 0 2em" : "0 2em 2em")};
  ${props => (props.$isFullWidth ? "" : "max-width: 450px;")}
  position: relative;
  text-align: center;
  .section {
    margin-bottom: 1em;
  }
  .oops {
    padding-top: 2em;
    padding-bottom: 1em;
  }
  .raven-error-retry {
    text-decoration: underline;
    color: ${darkBlue};
    cursor: pointer;
  }

  .raven-error-escape-link,
  a {
    text-decoration: underline;
    color: ${darkBlue};
  }
  .oops {
    font-size: 1.5em;
  }
  .error-info-wrapper {
    background: hsl(0, 0%, 95%);
    padding: 0.5em;

    .error-title {
      font-weight: bold;
    }
    .error-subtitle {
      padding: 0.5em 0;
    }
    .error-message {
      line-height: 1em;
      padding: 0.25em;
      &:first-child {
        margin-top: 0.25em;
      }
      &:last-child {
        margin-bottom: 0.25em;
      }
      background: hsla(0, 0%, 0%, 0.1);
      code {
        font-family: monospace;
      }
    }
  }
  .potential-solutions-wrapper {
  }
`;

type ErrorProps = {
  escapeRoute: string;
  escapeRouteName: string;
  errorTitle?: string;
  errorSubtitle?: string;
  errorMessage?: string;
  errorMoreInfo?: string;
  onRetry?: (() => void) | null;
  isFullWidth?: boolean;
};
export default function ErrorComponent({
  escapeRoute,
  escapeRouteName,
  onRetry,
  errorTitle = "",
  errorSubtitle = "",
  errorMessage,
  errorMoreInfo,
  isFullWidth = false,
}: ErrorProps) {
  const isMainPage = window.location.pathname === "/";

  const authContext = useAuth0();

  const handleSignInAgain = () => {
    if (authContext) {
      authContext.logout();
      authContext.loginWithRedirect();
    } else {
      console.log("tried to sign in again but found no auth context!");
    }
  };

  return (
    <ErrorStyles $isFullWidth={isFullWidth}>
      <div className="oops">Oops! Something went wrong...</div>
      <div className="error-info-wrapper section">
        {errorTitle && <div className="error-title">{errorTitle}</div>}
        {errorSubtitle && <div className="error-subtitle">{errorSubtitle}</div>}
        {errorMessage && (
          <div className="error-message">
            <code>{errorMessage}</code>
          </div>
        )}
        {errorMoreInfo && (
          <div className="error-message error-more-info">
            <code>{errorMoreInfo}</code>
          </div>
        )}
      </div>
      <div className="potential-solutions-wrapper section">
        {onRetry ? (
          <>
            <div>
              <span onClick={onRetry} className="raven-error-retry">
                Click to retry
              </span>
              {!isMainPage && (
                <>
                  {" "}
                  or return to the{" "}
                  <span className="raven-error-escape-link">
                    <Link to={escapeRoute}>{escapeRouteName}</Link>
                  </span>
                </>
              )}
              .
            </div>
            <div>
              You might also try to{" "}
              <span onClick={handleSignInAgain} className="raven-error-retry">
                sign-in again
              </span>
              .
            </div>
          </>
        ) : (
          <>
            {!isMainPage ? (
              <>
                <div>
                  <span className="raven-error-escape-link">
                    <Link to={escapeRoute}>
                      Click to return to the {escapeRouteName}
                    </Link>
                    .
                  </span>
                </div>
                <div>
                  You might also try to{" "}
                  <span
                    onClick={handleSignInAgain}
                    className="raven-error-retry"
                  >
                    sign-in again
                  </span>
                  .
                </div>
              </>
            ) : (
              <div>
                Please{" "}
                <span onClick={handleSignInAgain} className="raven-error-retry">
                  sign-in again
                </span>
                .
              </div>
            )}
          </>
        )}
      </div>
    </ErrorStyles>
  );
}
